var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeeklyOffEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 69,
    viewBox: "0 0 49 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6143 38.7782L35.2031 37.0547L28.8261 54.2899L26.7579 44.4658H26.9302C27.792 44.4658 28.6537 43.7764 28.6537 42.7423V40.5017C28.6537 39.64 27.9643 38.7782 26.9302 38.7782H23.1385C22.2767 38.7782 21.4149 39.4676 21.4149 40.5017V42.7423C21.4149 43.6041 22.1043 44.4658 23.1385 44.4658H23.3108L21.2426 54.2899L14.8656 37.0547L7.45441 38.7782C3.66266 39.64 1.07738 43.087 0.905029 47.0511V63.0799C0.905029 65.8375 3.14561 68.2504 5.90324 68.2504H43.9931C46.7507 68.2504 49.1636 66.0098 48.9913 63.0799L48.8189 47.0511C48.9913 43.087 46.406 39.64 42.6143 38.7782Z",
    fill: "#2E406F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0343 35.3298C34.5531 35.3298 42.2696 27.6133 42.2696 18.0946C42.2696 8.57584 34.5531 0.859375 25.0343 0.859375C15.5156 0.859375 7.79913 8.57584 7.79913 18.0946C7.79913 27.6133 15.5156 35.3298 25.0343 35.3298Z",
    fill: "#2E406F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeeklyOffEmptyIcon);
export default __webpack_public_path__ + "static/media/weeklyOffEmptyIcon.2fe52681e3bad2e504bdfae9bfe58c50.svg";
export { ForwardRef as ReactComponent };